<template>
  <div class="tx-ktgdealersearch module-search-results">
    <div class="search-results__header">
      <span class="heading epsilon" v-if="!location && !dealername && !bounds">{{ $t('searchResults.header.default') }}</span>
      <span class="heading epsilon" v-if="location">{{ $t('searchResults.header.location', { location }) }}</span>
      <span class="heading epsilon" v-if="dealername">{{ $t('searchResults.header.dealername', { dealername }) }}</span>
      <span class="heading epsilon" v-if="bounds">{{ $t('searchResults.header.bounds') }}</span>
    </div>
    <div class="search-results__filters-selected" v-if="initialized">
      <FilterSelected v-if="!mobile" />
      <div class="tx-ktgdealersearch module-sorting"></div>
    </div>
    <div class="search-results__results">
      <SearchResult
          :result="result"
          v-for="(result, index) in results"
          :key="result.id"
          @mouseenter="$emit('mouseenterResult', index)"
          @mouseleave="$emit('mouseleaveResult')"/>
      <template v-if="!initialized || loading">
        <div class="results__result results__result--loading"
             v-for="n in itemsPerPage"
             :key="'results__result--' + n + '-loading'">
          <div class="result__header">
            <div class="header__name"></div>
            <div class="header__meta">
              <div class="meta__service"><span></span></div>
              <div class="meta__distance"><span></span></div>
            </div>
          </div>
          <div class="result__content" v-if="!mobile">
            <div class="content__vehicle-types"></div>
            <div class="content__meta">
              <div class="meta-col">
                <div class="meta__location"><span></span></div>
                <div class="meta__phone"><span></span></div>
              </div>
              <div class="meta-col">
                <div class="meta__opening"><span></span></div>
              </div>
            </div>
          </div>
          <div class="result__content-mobile" v-if="mobile">
            <div class="content__location"><span></span></div>
            <div class="content__meta">
              <div class="meta__phone"><span></span></div>
              <div class="meta__opening"><span></span></div>
            </div>
          </div>
        </div>
      </template>
    </div>
    <div class="search-results__load-more">
      <div class="tx-ktgdealersearch module-load-more">
        <div class="load-more__button" v-if="currentPage < numberOfPages">
          <div class="btn -btn-alpha" @click="loadMore">
            <span>{{ $t('searchResults.loadMore.btn') }}</span>
          </div>
        </div>
        <div class="load-more__progress" v-if="initialized">
          <div class="progress__info">
            <span class="meta" v-html="$t('searchResults.loadMore.info', { current: results.length, total: numberOfTotalItems })"></span>
          </div>
          <div class="progress__bar"><span :style="{ width: (results.length / numberOfTotalItems * 100) + '%' }"></span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import FilterSelected from '@/components/FilterSelected'
import SearchResult from '@/components/SearchResult'

export default {
  name: 'SearchResults',
  inject: ['mobile'],
  components: {
    FilterSelected,
    SearchResult
  },
  computed: {
    ...mapState({
      initialized: state => state.initialized,
      brand: state => state.brand,
      loading: state => !state.dealer.loaded,
      results: state => state.dealer.items,
      currentPage: state => state.dealer.currentPage,
      itemsPerPage: state => state.dealer.itemsPerPage,
      numberOfPages: state => state.dealer.numberOfPages,
      numberOfTotalItems: state => state.dealer.numberOfTotalItems,
      dealername: state => state.filter.dealername,
      location: state => state.filter.location,
      bounds: state => state.filter.swLatitude && state.filter.swLongitude && state.filter.neLatitude && state.filter.neLongitude,
      model: state => state.filter.model
    })
  },
  methods: {
    ...mapActions([
      'loadMore'
    ])
  }
}
</script>
